<template>
  <v-app id="app">
    <Navigation :drawer="drawer" :subMenuDrawer="subMenuDrawer" :showMenu="showMenu"/>
  <v-container class="mt-5 pl-12">
    <v-main>
      <PasswordChange  :saveNewPwd="(data)=> saveNewPwd(data)"/>
    </v-main>
    <Footer/>
    </v-container>
  </v-app>
</template>

<script>
import Navigation from "@/components/common/Navigation"
import PasswordChange from "@/components/auth/PasswordChange"
export default {
  components:{
    Navigation,
    PasswordChange
  },
  data: () => ({
    drawer: true,
    showMenu: false,
    userData: null
  }),
  mounted() {
      this.userData = this.$store.state.userData.userData
      this.showMenu = true
  },
  methods: {
      saveNewPwd(formData) {
        let obj = {
          query: [{ 
              Modulo: "Portal",
              Acao: "changepassword",
              Payload: {
                id: this.userData.Id,
                grupo_economico: this.userData.grupo_economico,
                Password: formData.password,
                PasswordConfirm: formData.passwordConfirm
              }
          }]
        }
        this.$store.dispatch("request/doRequest", obj).then(response => {
          if(!response || response.isAxiosError || !response.sucesso) {
            this.$store.commit("hideLoader")
            return
          }
          let paramModal = {
            type: 'success',
            title: 'Sucesso!',
            message: response.mensagem,
            callback: () => this.updateDataUser(),
            btConfirm: { name: 'Ok', show: true}
          }
          this.$store.commit('confirmMessage/showConfirmMessage', paramModal)
          
        })
      }, 
      updateDataUser(){
        let token = sessionStorage.getItem('token')
        let obj = {
          query: [
            {
              Modulo: "portal",
              Acao: "getuser",
              Payload: {
                id: this.userData.Id,
                grupo_economico: this.userData.grupo_economico,
              },
            },
          ],
          NoLoader: true,
          token
        };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (response && response.sucesso) {
          this.$store.commit("userData/updateUserData", response, { root: true });
        }
        this.$router.push("/")
      })
    }
  }
}
</script>
<style>
.nav-menu {
  display: flexbox;
  max-width: 120px !important;
}

.nav-menu.mini {
  max-width: 70px !important;
}

.v-navigation-drawer--mini-variant .v-list-item > *:first-child {
  margin-left: auto;
  margin-right: auto;
}
a.menu-btn {
  display: block;
  margin: 0 auto;
}
.menu-btn,
.menu-btn-label {
  display: block;
  width: 100%;
  text-align: center;
}
</style>